import { defineStore } from 'pinia'
import type { ApiError, FetchOptions } from '@/utils/types'
import type {
  FundingRateGroupResponse,
  FundingRateGroupsRequest,
} from '@/services/funding-rates-v2-service/types'
import { FundingRatesV2Service } from '@/services/funding-rates-v2-service'
import { FALLBACK_API_ERROR } from '@/utils/consts'
import axios from 'axios'

export const useFundingRateGroupsStore = defineStore('funding-rate-groups', {
  state: () => ({
    loading: true,
    error: null as ApiError | null,
    page: 1 as number,
    pages: 0 as number,
    // priceNum: 0 as number,
    pageSize: 10 as number,
    alerts: [] as FundingRateGroupResponse[],
    filters: {} as FundingRateGroupsRequest,
  }),
  getters: {},
  actions: {
    clear() {
      this.loading = true
      this.alerts = []
    },
    async fetch(page: number, opts: FetchOptions = {}) {
      if (!opts.keepState) {
        this.loading = true
      }
      try {
        const filtersCopy = { ...this.filters }
        if (filtersCopy.symbols) {
          filtersCopy['symbols'] = filtersCopy['symbols'].map((x: string) =>
            x.endsWith(':USDT') ? x : `${x}/USDT:USDT`.toUpperCase(),
          )
        }
        const req = await FundingRatesV2Service.fetchFundingRateGroups(page, filtersCopy)
        this.alerts = req.data.rates
        this.pages = req.data.pages
        this.pageSize = req.data.page_size
      } catch (thrown) {
        if (axios.isAxiosError(thrown) && thrown.response) {
          this.error = {
            message: thrown.response?.data,
            code: thrown.response?.status,
          }
        } else {
          this.error = FALLBACK_API_ERROR
        }
      } finally {
        this.loading = false
      }
    },
  },
})
